import { render, staticRenderFns } from "./DeliveryInformation.vue?vue&type=template&id=42480a4c"
import script from "./DeliveryInformation.vue?vue&type=script&lang=ts"
export * from "./DeliveryInformation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports